import React, { Fragment } from "react";
import Header from "../../theme-components/Header/Header";
import AppSidebar from "../../theme-components/AppSidebar/AppSidebar";
import Footer from "../../components/Footer/Footer";

const ComponetWithHeader = ({ component: Component, ...rest }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <div className="app-main" style={{ flex: '1 0 auto', display: 'flex' }}>
        <AppSidebar {...rest} />
        <div className="app-main__outer" style={{ display: 'flex', flexDirection: 'column', flex: '1' }}>
          <div className="app-main__inner" style={{ flex: '1' }}>
            <Component {...rest} />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ComponetWithHeader;
